import { useContext, useEffect, useState } from "react";
import AdvancedSearchForm from '../components/AdvancedSearchForm';
import { init_newUserDataObj, UserData, UserSearchQuery, UserSearchResult } from '../interfaces/UserInterfaces';
import { COSMOS_API, POST_ENDPOINT } from "../api/API";
import { SearchResultTable } from "../components/SearchResultTable";
import { useLocation, useNavigate } from "react-router-dom";
import { AppEnvSetting, isNullUndefEmpty } from "../ts/common";
import { AdminContext } from "../contexts/AdminContext";
import { Paper, useTheme } from "@mui/material";


// The search API call only happens when the query string changes. When clicking the search button or any pagination options the page is navigated to a new query string
function SearchUsersPage() {
    const {adminCredentials, getToken} = useContext(AdminContext);
    // const [searchQuery, setSearchQuery] = useState<UserSearchQuery>({
    //     email: '', 
    //     country: AppEnvSetting.defaultCountry, 
    //     firstName: '', 
    //     lastName: '', 
    //     organizationId: adminCredentials.isSuperAdmin ? '' : adminCredentials.organizationId, 
    //     applicationId: '', 
    //     userProvisionStatus: ''
    // })
    const [searchResults, setSearchResults] = useState<Array<UserSearchResult> | undefined>();
    let query = new URLSearchParams(useLocation().search);
    const hasSearched = query !== null && query !== undefined && query.toString() !== '';
    const [searchInProgress, setSearchInProgress] = useState(false);
    let navigate = useNavigate();

    

    // The search API call only happens when the query string changes. When clicking the search button or any pagination options the page is navigated to a new query string
    // useEffect(() => {
    //     if (hasSearched) {
    //         let queryCount = 0;
    //         let queryOffset = 0;
    //         if (query.has('count')) queryCount = parseInt(query.get('count') ?? '10')
    //         if (query.has('offset')) queryOffset = parseInt(query.get('offset') ?? '0');
    //         let newSearchQuery = constructUserFromQueryString();
    //         setSearchQuery(newSearchQuery);
    //         sendSearchRequest(newSearchQuery, [queryCount, queryOffset]);
    //     }
    // }, [query]);

    function constructUserFromQueryString(): UserSearchQuery {
        var queryStructure: UserSearchQuery = {
            email: '', 
            country: AppEnvSetting.defaultSearchUsersToAllCountries === true ? "all" : AppEnvSetting.defaultCountry, 
            firstName: '', 
            lastName: '', 
            organizationId: adminCredentials.isSuperAdmin ? '' : adminCredentials.organizationId, 
            applicationId: '',
            userProvisionStatus: ''
        };

        query.forEach((value: string, key: string) => {
            if (value !== null) {
                if (key !== 'offset' && key !== 'count') {
                    queryStructure = { ...queryStructure, [key as keyof UserSearchQuery]: value };
                }
            }
        });

        return queryStructure;
    }

    function userToQueryString(user: UserSearchQuery, newCountOffset: [number, number]):string {
        const searchRedirect = new URLSearchParams();
        let key: keyof UserSearchQuery;
        for(key in user){
            if(!isNullUndefEmpty(user[key])){
                searchRedirect.append(key, user[key]);
            }
        }
        searchRedirect.append("count", String(newCountOffset[0]));
        searchRedirect.append("offset", String(newCountOffset[1]));

        return searchRedirect.toString();
    }

    function navigatePage(newCountOffset: [number, number]) {
        let newUrlSearchParams = query;
        newUrlSearchParams.set("count", String(newCountOffset[0]));
        newUrlSearchParams.set("offset", String(newCountOffset[1]));

        redirectWithNewSearchParams(newUrlSearchParams.toString());
    }

    function newQuery(newParams: UserSearchQuery) {
        // New query so we want to set the count and offset to default to avoid any weird bounding issues
        let newQueryString = userToQueryString(newParams, [10,0]);
        redirectWithNewSearchParams(newQueryString);
    }

    function redirectWithNewSearchParams(queryString: string) {
        setSearchInProgress(true);
        navigate({
            pathname: '/search-users',
            search: queryString
        });
    }

    const handleSearchResults = (results: any): Array<UserSearchResult> => {
        if (results.users === undefined) return [];
        setNumResults(results.numResults);
        const usersResult = results.users.map((obj: UserSearchResult) => {
            if (obj.firstName === null) {
                obj.firstName = "";
            }
            if (obj.lastName === null) {
                obj.lastName = "";
            }
            if (obj.country === null) {
                obj.country = "";
            }
            if (obj.userType === null) {
                obj.userType = "";
            }
            if (obj.isActive === null) {
                obj.isActive = false;
            }
            if (obj.defaultLanguage === null) {
                obj.defaultLanguage = "";
            }
            if (obj.isFederated === null) {
                obj.isFederated = false;
            }
            if (obj.organizations === null) {
                obj.organizations = [];
            } else {
                obj.organizations = Object.keys(obj.organizations).map(orgKey => adminCredentials.organizationList.find(oli => oli.id === orgKey)?.name).filter(oentry => !!oentry) as string[];
            }
            // Application object has not been standardized so need to just keep keys for now
            // Will eventually just want an object with uuid to App mapping with a standard App interface (defined in UserInterfaces.ts)
            return { ...obj };
        });

        return usersResult;
    }

    const sendSearchRequest = async (newSearchQuery: UserSearchQuery, newCountOffset:[number, number]) => {
        //setCountOffset(newCountOffset);
        let search: UserData = init_newUserDataObj();
        search.email = newSearchQuery.email;
        search.firstName = newSearchQuery.firstName;
        search.lastName = newSearchQuery.lastName;
        // @ts-ignore
        search.country = newSearchQuery.country === "all" ? null : newSearchQuery.country;
        if(!isNullUndefEmpty(newSearchQuery.organizationId)){
            search.organizations = { [newSearchQuery.organizationId]: {}};
        }
            if(!isNullUndefEmpty(newSearchQuery.applicationId)){
            if (adminCredentials.allApplications[newSearchQuery.applicationId]?.isGlobal) {
                search.applications = { [newSearchQuery.applicationId]: {} };
                if(newSearchQuery.userProvisionStatus !== ""){
                    search.applications[newSearchQuery.applicationId].userProvisionStatus = newSearchQuery.userProvisionStatus;
                }
            } else {
                search.organizations[newSearchQuery.organizationId] = {[newSearchQuery.applicationId]: {}};

                if(newSearchQuery.userProvisionStatus !== ""){
                    search.organizations[newSearchQuery.organizationId][newSearchQuery.applicationId].userProvisionStatus = newSearchQuery.userProvisionStatus;
                }
            }
        }
        
        search.isActive = undefined;

        var body: any = {
            user: search,
            count: newCountOffset[0],
            offset: newCountOffset[1]
        }

        if(searchInProgress){
            setSearchInProgress(false);
            setSearchResults(undefined);
        const results = await COSMOS_API.POST(body, POST_ENDPOINT.SearchUsers, getToken());

        if(results.ok && results.respBody !== undefined && results.respBody !== null){
            const cleanedResults = handleSearchResults(results.respBody);
    
            setSearchResults([...cleanedResults]);
        } else {
            setSearchResults([]);
        }
    }
    }

    const resetSearch = () => {
        navigate('/search-users');
        // setSearchQuery({
        //     email: '', 
        //     country: AppEnvSetting.defaultCountry, 
        //     firstName: '', 
        //     lastName: '', 
        //     organizationId: adminCredentials.isSuperAdmin ? '' : adminCredentials.organizationId, 
        //     applicationId: '', 
        //     userProvisionStatus: ''
        // });
        // setCountOffset([10,0]);
        setSearchResults(undefined);
        setNumResults(0);
    }
    
    
    const searchQuery = constructUserFromQueryString();
    const countOffset: [number, number] = [parseInt(query.get('count') ?? '10'), parseInt(query.get('offset') ?? '0')];
    const [numResults, setNumResults] = useState<number>(0);

    useEffect(() => {
        if(hasSearched && searchInProgress){
            sendSearchRequest(searchQuery, countOffset);
        }
    },[query])
    

    const theme = useTheme();
    return (
        <Paper 
          component={"main"} 
          className='off-white'
          sx={{backgroundColor: theme.palette.background.default}}
        >
            <>
                <div className="container">
                        <AdvancedSearchForm
                            resetSearch={resetSearch}
                            searchQuery={searchQuery}
                            newQuery={newQuery}
                            countOffset={countOffset}
                        />
                        {searchResults !== undefined ?
                            <SearchResultTable
                                searchResults={searchResults}
                                numResults={numResults}
                                navigatePage={navigatePage}
                                countOffset={countOffset}
                            /> : hasSearched ? <h3>Please wait for results</h3> : null}
                </div>
            </>
        </Paper>
    )
}

export default SearchUsersPage
